/**
 * @file common/enum
 * @author fengfaxia(fengfaxia@baidu.com))
 * Copyright (c) 2018-07-06 Baidu
 */
export const createResponseCode = {
    '-1': '短网址生成失败，请重试',
    '-2': '您输入的网址不合法，请重新输入',
    '-3': '您输入的网址存在安全隐患，不予生成短网址',
    '-4': '短网址注册失败，请重试',
    '-5': '长网址在黑名单中，不允许注册',
    '-6': '有效期设置错误，请重置有效期'
};
export const queryResponseCode = {
    '-1': '您查询的网址不合法，被禁止使用',
    '-2': '您输入的短网址不存在，请重新输入',
    '-3': '查询的短网址不合法'
};
export const tokenUpdateCode = {
    '-1': '用户不存在',
    '-2': '生成token失败',
    '-3': '操作过于频繁'
};





